import { xScreen } from "@flip/XDL/Utilities";
import { quickOrderSearchStyles } from "@insite/content-library/Widgets/QuickOrder/QuickOrderSearch";
import { css } from "styled-components";

quickOrderSearchStyles.productSelector = {
    buttonGridItem: {
        width: [12, 12, 4, 4, 4],
        css: css`
            max-width: fit-content;
        `,
    },
    selectButton: {
        css: css`
            margin-top: 21px;
            ${xScreen("lte", "xs")} {
                padding: 0 10px;
                white-space: nowrap;
                min-width: fit-content;
                width: 100%;
            }
        `,
    },
};
